import { Component, OnInit, ChangeDetectorRef, HostListener, NgZone } from "@angular/core";
import { AuthenticationService } from "Services/authentication.service";
import { FetchDataService } from "Services/fetch-data.service";
import { EventService } from "Services/event.service";
//import { AdalService } from "ng2-adal/dist/core";
import { Adal4Service as AdalService } from 'adal-angular4';
import { AppConfig } from "Classes/AppConfig";
import { CookieManagementService as CookieService } from "Services/cookie-management.service";
import { ModalConfig } from "Classes/ModalConfig";
declare var $: any;

@Component({
    selector: "main-page",
    template: require('./main-page.component.html'),
    styles: [require('./main-page.component.css')]
})

export class MainPageComponent implements OnInit {
    constructor(
        private authenticationService: AuthenticationService,
        private fetchDataService: FetchDataService,
        private eventService: EventService,
        private appConfig: AppConfig,
        private adalService: AdalService,
        private cookieService: CookieService,
        private changeDetectorRef: ChangeDetectorRef,
        private zone: NgZone
    ) {
    }


    loadingText: string = "";
    showSpinner: boolean = false;
    displayModal: boolean = false;
    accountInfo: boolean = false;
    userManagement: boolean = false;
    login: boolean = false;
    validationDone: boolean = false;
    listeners: any[] = [];
    modalConfig: ModalConfig;
    errorMessage: string = "";
    silentLogoutFlag: boolean = false;
    silentLogoutUrl: string = "";
    usedSSO: boolean = false;

    //Hostname
    hostnameArray: string[] = window.location.hostname.split('.');
    hostName: string = this.hostnameArray[this.hostnameArray.length - 2] ;

    fetchingUsers: string = "Fetching Users...";

    //@HostListener("window:adal:popUpHashChanged", ['$event'])
    //onHashChanged(a, b)
    //{
    //    //if(this.adalService.userInfo.authenticated)
    //    if (a.detail)
    //    {
    //        let adalContext = (window as any).AuthenticationContext.prototype._singletonInstance;

    //        adalContext.handleWindowCallback(a.detail);
    //    }
    //    else
    //        this.loginWithSSO(a, b);
    //}

    ngOnInit(): void
    {
       
        this.silentLogoutUrl = "https://login.microsoftonline.com/" + this.appConfig.azureTenant + "/oauth2/logout?" + "about:blank";
        this.componentEvents();
        
        let logOutTrue = this.getParameterByName("LogOff");
        let redirect = this.cookieService.get("Redirect");
        if (redirect)
        {
            this.fetchDataService._redirectURL = redirect;
            this.cookieService.removeAll();
        }
        if (logOutTrue === "true")
        {
            this.cookieService.removeAll();
            if (redirect)
                this.cookieService.put("Redirect", redirect);
            if (this.adalService.userInfo.authenticated)
                this.adalService.logOut();
            else
                window.location.replace(process.env.PORTAL_URL);
            return;
        }
        let AuthData: any = {
            AccessToken: this.cookieService.get("RslAppPageToken"),
            CmToken: this.cookieService.get("CmToken"),
            AmsToken: this.cookieService.get("AmsToken"),
            FName: this.cookieService.get("FName"),
            LName: this.cookieService.get("LName")
        };
        this.loadingText = "Checking for token...";
        this.showSpinner = true;

        if (AuthData.AccessToken || AuthData.CmToken || AuthData.AmsToken)
        {
            this.authenticationService.validateTokens(AuthData).subscribe(data =>
            {
                var expireDate = new Date((new Date()).getTime() + this.fetchDataService.expireMinutes * 60 * 1000);

                this.fetchDataService._usedSSO = (this.cookieService.get("SSO") == "true");
                this.usedSSO = this.fetchDataService._usedSSO;
                if (!data.AccessToken)
                    delete AuthData.AccessToken;
                if (!data.CmToken)
                    delete AuthData.CmToken;
                if (!data.AmsToken)
                    delete AuthData.AmsToken;
                if (!data.AccessToken && !data.CmToken && !data.AmsToken)
                {
                    this.cookieService.removeAll();
                    this.showSpinner = false;
                    this.validationDone = true;
                }
                else
                {
                    AuthData.FName = this.cookieService.get("FName");
                    AuthData.LName = this.cookieService.get("LName");
                    AuthData.UserId = this.cookieService.get("UserId");
                    this.authenticationService.setAuthData(AuthData);
                    this.authenticationService.setUserData(this.cookieService.get("Login"));
                    this.loadingText = "Fetching Apps...";
                    this.fetchDataService.fetchApps().subscribe(
                        apps =>
                        {
                            this.fetchDataService.getUserByEmail().subscribe(data =>
                            {
                                if (data.fName)
                                    this.authenticationService._firstName = data.fName;
                                if (data.lName)
                                    this.authenticationService._lastName = data.lName;
                                this.fetchDataService.setUserRoles(data.role ? data.role : [])
                                this.fetchDataService.setApps(apps);
                                this.validationDone = true;
                                this.showSpinner = false;
                                this.login = true;
                                this.usedSSO = this.fetchDataService._usedSSO || !this.fetchDataService.getToken("access");

                            }, error =>
                                {
                                    this.validationDone = true;
                                    this.cookieService.removeAll();
                                    this.showSpinner = false;
                                })
                        }, error =>
                        {
                            this.login = false;
                            this.validationDone = true;
                            this.cookieService.removeAll();
                            this.showSpinner = false;
                        });
                }
            }, error =>
                {
                    this.validationDone = true;
                    this.cookieService.removeAll();
                    this.showSpinner = false;
                });
        } else
        {
            this.validationDone = true;
            this.showSpinner = false;
            this.login = false;
            this.cookieService.removeAll();
        }

        //setTimeout(() => {
        //let loginData: any;
        //if (loginData) {
        //    loginData = JSON.parse(loginData);
        //    this.fetchDataService.setAuthData(loginData);
        //    this.login = true;
        //    if (loginData.permission === this.fetchDataService.admin) {
        //        this.showSpinnerEvent(this.fetchingUsers);
        //        this.fetchDataService.fetchUsers().subscribe(
        //            (users) => {
        //                ref.fetchDataService.saveUsers(users);
        //                ref.closeSpinnerEvent();
        //            }, (error) => {
        //                ref.closeSpinnerEvent();
        //            }
        //        );
        //    }
        //}
        //else {
        //    this.login = false;
        //    //this.login = true;
        //}
        //}, 500);
        //}, 1000);
    }

    getParameterByName(name: string): string {
        // if (!url) {
        var url = window.location.href.toLowerCase();
        //}
        name = name.replace(/[\[\]]/g, "\\$&");
        name = name.toLowerCase();
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results)
        {
            regex = new RegExp("[#&]" + name + "(=([^&#]*)|&|#|$)");
            results = regex.exec(url)
        };
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }


    closeModal(): void {
        this.displayModal = false;
        this.eventService.broadcast(this.eventService._focusBigButton);
    }

    loginWithSSO(a, b): void
    {
        this.eventService.broadcast(this.eventService._loginWithSSO);
    }

    componentEvents(): void {
        let ref = this;
        this.listeners.push(this.eventService.on(this.eventService._displayModal, function (modalConfig: ModalConfig) {
            let tempOk = modalConfig.ok;
            modalConfig.ok = () => {
                tempOk();
                ref.closeModal.bind(ref)();
            }
            let tempCancel = modalConfig.cancel;
            modalConfig.cancel = () => {
                tempCancel();
                ref.closeModal.bind(ref)();
            }
            ref.modalConfig = modalConfig;
            ref.displayModal = true;
            //ref.changeDetectorRef.detectChanges();

        }));
        this.listeners.push(this.eventService.on(this.eventService._showSpinner, function (loadingText: string) {
            ref.showSpinnerEvent(loadingText);
            //ref.changeDetectorRef.detectChanges();
        }));
        this.listeners.push(this.eventService.on(this.eventService._closeSpinner, function (loadingText: string) {
            ref.closeSpinnerEvent();
            //ref.changeDetectorRef.detectChanges();
        }));
        this.listeners.push(this.eventService.on(this.eventService._openAccountInfo, function () {
            ref.accountInfo = true;
            //ref.changeDetectorRef.detectChanges();
        }));
        this.listeners.push(this.eventService.on(this.eventService._openUserManagement, function () {
            ref.userManagement = true;
            //ref.changeDetectorRef.detectChanges();
        }));
        this.listeners.push(this.eventService.on(this.eventService._goToPage, function(uri: string, type: string)
        {
            var expireDate = new Date((new Date()).getTime() + ref.fetchDataService.expireMinutes * 60 * 1000);

            uri = uri.replace("apge", "page");
            ref.cookieService.put("UserGuid", ref.fetchDataService._userGuid, expireDate);
            ref.cookieService.put("Email", ref.fetchDataService.getEmail(), expireDate);
            if (type.toLowerCase() === "smc") {

                //ref.cookieService.put("RslAppPageLogin", ref.authenticationService._userName, { 'expires': expireDate, 'domain': ".doerer.us" });
                //ref.cookieService.put("RslAppPageFName", ref.authenticationService._firstName, { 'expires': expireDate, 'domain': ".doerer.us" });
                //ref.cookieService.put("RslAppPageLName", ref.authenticationService._lastName, { 'expires': expireDate, 'domain': ".doerer.us" });
                //ref.cookieService.put("RslAppPageToken", ref.authenticationService.getRawToken("smc"), { 'expires': expireDate, 'domain': ".doerer.us" });
                ref.cookieService.put("RslAppPageUserId", ref.authenticationService._userId, expireDate);
                ref.cookieService.put("RslAppPageLogin", ref.authenticationService._userName, expireDate);
                ref.cookieService.put("RslAppPageFName", ref.authenticationService._firstName, expireDate);
                ref.cookieService.put("RslAppPageLName", ref.authenticationService._lastName, expireDate);
                window.location.assign(uri);
            } else if (type.toLowerCase() === "rams" || type.toLowerCase() === "cm") {
                ref.cookieService.put("RamsFName", ref.authenticationService._firstName, expireDate);
                ref.cookieService.put("RamsLName", ref.authenticationService._lastName, expireDate);
                ref.cookieService.put("RamsLogin", ref.authenticationService._ramsUserName, expireDate);
                window.location.assign(uri);
            } 
            else if (type.toLowerCase() === "gis") {

                var expireDate = new Date((new Date()).getTime() + ref.fetchDataService.expireMinutes * 60 * 1000);

                ref.fetchDataService.getGisTokenCookie().subscribe((data) => {

                    var gisCookie = data.tokenCookie;
                    ref.cookieService.put("esri_auth", gisCookie, expireDate);
                    window.location.assign(uri);
                });

                //Don't navigate to GIS until after additional call to the auth service for GIS creds.
            }
            else {
                ref.cookieService.put("elsehit", "yup", expireDate);
                ref.cookieService.put("CType", type, expireDate);
                window.location.assign(uri);
            }

            // Hello there
           // window.location.assign(uri);
        }))
        this.listeners.push(this.eventService.on(this.eventService._silentLogout, async (redirect: boolean = false) =>
        {
            this.silentLogoutFlag = true;
            if (redirect)
            {
                let ref = this;
                let user;
                this.showSpinnerEvent("Loading "+this.hostName+" Login...");
                //let interval = setInterval(async () =>
                //{
                //    let azureAccessToken;
                //    let tokenData;
                //    try
                //    {
                //        this.adalService.clearCacheForResource(this.appConfig.azureResourceId);
                //        azureAccessToken = await this.adalService.acquireToken(this.appConfig.azureResourceId).toPromise();

                //    } catch (e) { }
                //    if (!azureAccessToken)
                //    {
                //        this.adalService.clearCache();
                //        ref.silentLogoutFlag = false;
                //        clearInterval(interval);
                //        $('iframe[id^="adalRenewFrame"]').remove();
                //        ref.authenticationService.redirectToAzureAD();
                //    }
                //}, 1000);
                let success = await this.poll(
                    async () =>
                    {
                        let azureAccessToken;
                        let tokenData;
                        try
                        {
                            this.adalService.clearCacheForResource(this.appConfig.azureResourceId);
                            azureAccessToken = await this.adalService.acquireToken(this.appConfig.azureResourceId).toPromise();
                            $('iframe[id^="adalRenewFrame"]').remove();
                        } catch (e) { }
                        if (!azureAccessToken)
                        {
                            this.adalService.clearCacheForResource(this.appConfig.azureResourceId);
                            this.silentLogoutFlag = false;
                            this.authenticationService.redirectToAzureAD();
                            return new Promise<boolean>(resolve => resolve(true));
                        }
                        return new Promise<boolean>(resolve => resolve(false));
                    }, 1000, 20000);

                this.closeSpinnerEvent();
                if (!success)
                    this.adalService.logOut();
                    

            }
        }));
        this.listeners.push(this.eventService.on(this.eventService._signInWithSSO, () =>
        {
            this.authenticationService.redirectToAzureAD();
        }))
        this.listeners.push(this.eventService.on(this.eventService._loginWithSSO, (idToken) =>
        {
            ref.showSpinner = true;
            ref.loadingText = "Authenticating...";
            let smcToken = this.cookieService.get("smc_token");

            this.zone.runOutsideAngular(() =>
            {
                this.adalService.acquireToken(this.appConfig.azureResourceId).subscribe(
                    azureAccessToken =>
                    {
                        this.zone.run(() =>
                        {
                            if (smcToken)
                            {
                                this.cookieService.remove("smc_token");
                                this.authenticationService.registerCredentials(azureAccessToken, smcToken).subscribe(
                                    data =>
                                    {
                                        ref.usedSSO = true;
                                        ref.fetchDataService._usedSSO = true;
                                        ref.showSpinner = false;
                                        if (!data.Success)
                                        {
                                            // Silent Logout
                                            ref.showOnLandingPage("Server Error", false);
                                        }
                                        else
                                        {
                                            ref.showOnLandingPage(this.hostName+" Credentials Successfully Registered!", true)
                                        }
                                    },
                                    error =>
                                    {
                                        // Silent Logout
                                        ref.showSpinner = false;
                                        ref.showOnLandingPage(error, false);
                                        ref.validationDone = true;
                                    });
                            }
                            else
                            {
                                this.authenticationService.getTokenResponse(azureAccessToken).subscribe(
                                    data =>
                                    {
                                        //console.log(data)
                                        ref.usedSSO = true;
                                        ref.fetchDataService._usedSSO = true;
                                        ref.showSpinner = false;
                                        ref.handleTokenResponse(data);
                                        //ref.changeDetectorRef.detectChanges();
                                    },
                                    error =>
                                    {
                                        ref.showSpinner = false;
                                        ref.errorMessage = "Invalid "+this.hostName+" Credentials. Please sign in with your SMC account instead if you have not yet configured your "+this.hostName+" account for single sign-on.";
                                        ref.validationDone = true;
                                        //ref.changeDetectorRef.detectChanges();
                                        ref.silentLogout();
                                    });
                            }
                        });
                        //this.handleTokenResponse(azureToken);
                    },
                    err =>
                    {
                        this.zone.run(() =>
                        {
                            ref.showSpinner = false;
                            ref.showOnLandingPage(err, false, ref.silentLogout.bind(this));
                        });
                    }

                )
            });
        }))

    }

    async silentLogout()
    {
        //let w: any = window;
        //if (w.childFrame)
        //{
        //    w.childFrame.location.replace(process.env.PORTAL_URL + "?LogOff=true");
        //    //delete w.childFrame;
        //    //$("body").find("iframe").remove();
        //}
        //else
        //{
        this.adalService.clearCacheForResource(this.appConfig.azureResourceId);
        let azureAccessToken = await this.adalService.acquireToken(this.appConfig.azureResourceId).toPromise();
        if (azureAccessToken)
            this.adalService.logOut();
        //}
    }

    showSpinnerEvent(loadingText: string): void {
        this.loadingText = loadingText;
        this.showSpinner = true;
    }

    closeSpinnerEvent(): void {
        this.showSpinner = false;
    }

    allowTab(e: any) {
        if (this.showSpinner || this.displayModal || this.accountInfo || this.userManagement)
            e.preventDefault();
    }

    handleTokenResponse(tokenResponse)
    {
        if (tokenResponse)
            this.normalizeResponse(tokenResponse);
        if (tokenResponse && tokenResponse.Success)
        {
            
            this.authenticationService.setAuthData(tokenResponse);
            this.authenticationService.setUserData(this.fetchDataService.getEmail());
            this.fetchDataService.fetchApps().subscribe(
                (apps) =>
                {
                    this.fetchDataService.setApps(apps);
                    this.fetchDataService.getUserByEmail().subscribe(data =>
                    {
                        if (data.fName)
                            this.authenticationService._firstName = data.fName;
                        if (data.lName)
                            this.authenticationService._lastName = data.lName;
                        if (data.id)
                            this.fetchDataService._userGuid = data.id;
                        this.fetchDataService.setUserRoles(data.role ? data.role : [])
                        this.login = true;
                        this.usedSSO = this.fetchDataService._usedSSO || !this.fetchDataService.getToken("access");
                        this.validationDone = true;
                        this.showSpinner = false;
                        //this.changeDetectorRef.detectChanges();
                    }, error =>
                        {
                        this.login = false;
                        this.validationDone = true;
                        this.cookieService.removeAll();
                        this.showSpinner = false;
                        //this.changeDetectorRef.detectChanges();

                        });
                }, (error) =>
                {
                    this.errorMessage = "Invalid "+this.hostName+" Credentials";
                    this.login = false;
                    this.validationDone = true;
                    this.cookieService.removeAll();
                    this.showSpinner = false;
                    //this.changeDetectorRef.detectChanges();

                });
        }
        else
        {
            this.showSpinner = false;
            this.login = false;
            this.errorMessage = tokenResponse.Error;
        }
    }

    normalizeResponse(res: any)
    {
        for (let key in res)
        {
            let capKey = key[0].toUpperCase() + key.slice(1);
            res[capKey] = res[key];
            delete res[key];
        }
    }

    showOnLandingPage(error: string, success: boolean = false, cancelCallback?)
    {
        // Display error on main page.
        this.showSpinner = false;
        this.changeDetectorRef.detectChanges();
        let modalConfig: ModalConfig;
        let emptyCallback = () => { };
        if (success)
        {
            modalConfig = new ModalConfig(
                "alert",
                "Register Credentials for SSO",
                error,
                $("#email"),
                cancelCallback || emptyCallback
            );
        }
        else
        {
            modalConfig = new ModalConfig(
                "alert",
                "Registration Failed!",
                (error.indexOf("SMC User") >= 0) ? error : error + "\n\nYou may still be signed into your "+this.hostName+" account. Be sure to sign out before you sign off.",
                $("#email"),
                cancelCallback || emptyCallback
            );
        }
        this.eventService.broadcast(this.eventService._displayModal, modalConfig);
        this.fetchDataService._usedSSO = true;
        if (this.cookieService.get("SSO") != null)
        {
            this.cookieService.remove("SSO");
        }
        this.cookieService.put("SSO", true);
        
        console.log(error);
        console.log(success);
    }

    async poll(callback: () => Promise<boolean>, pollTime, maxTime)
    {
        let maxTries = Math.round(maxTime / pollTime);
        let tries = 0;
        let done = false;
        while (!done && tries < maxTries)
        {
            done = await callback();
            await new Promise(resolve => setTimeout(() => resolve(false), pollTime));
            tries++;
        }

        return new Promise(resolve => resolve(done));
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/main-page.component.ts